import { useEffect } from "react";

/**
 * Sets document.title per-page. Restores previous title on unmount.
 */
export const useDocumentTitle = (title) => {
  useEffect(() => {
    const previous = document.title;
    const full = title
      ? `${title} · Akyvia Sciences and Technologies`
      : "Akyvia Sciences and Technologies — Innovating Science. Engineering Tomorrow.";
    document.title = full;
    return () => {
      document.title = previous;
    };
  }, [title]);
};

export default useDocumentTitle;
